module.exports = __webpack_public_path__ + "img/山东省软件行业协会会员证书.7d5a1bf5.jpg";